import initialState from './state.js'

const RESET_STATE = (state) => {
  let iState = initialState.get();
  //Preserve fetching state
  iState.fetching = state.fetching;
  Object.assign(state, iState);
};

const FETCHING = (state, value) => {
  state.fetching = !!value;
};

const FETCH_SUCCESS = (state, value) => {
  state.success = !!value;
};

const FETCH_ERROR = (state, value) => {
  state.error = value;
};

const SET_DETAILS = (state, values) => {
  state.details = values;
};

export default {
  FETCHING,
  FETCH_SUCCESS,
  FETCH_ERROR,
  SET_DETAILS,
  RESET_STATE,
};
